import { Analytics } from "@vercel/analytics/react";
import { useRoomData } from "./hooks/useRoomData.js";
import { TopBarMobile } from "./components/TopBarMobile.js";
import { FlatView } from "./components/FlatView.js";
import { WelcomeModal, useWelcomeModal } from "./components/WelcomeModal.js";
import { GROUPS } from "./groups.js";
import styles from "./styles/MobileApp.module.css";
import "./index.css";

export function MobileApp() {
  const { show: showWelcome, dismiss: dismissWelcome } = useWelcomeModal();

  const {
    snapshot,
    isLoading,
    searchQuery,
    filteredSections,
    suppressed,
    readIds,
    markRead,
    isHomeRoom,
    roomId,
    userRooms,
  } = useRoomData();

  return (
    <div className={styles.app}>
      <TopBarMobile />

      {isLoading && <div className={styles.loadingBar} />}

      <main className={styles.content}>
        {!snapshot ? (
          <div className={styles.loading}>Loading…</div>
        ) : (
          <FlatView
            sections={filteredSections}
            readIds={readIds}
            onRead={markRead}
            suppressed={suppressed}
            highlight={searchQuery || undefined}
            mobile
            roomTitle={isHomeRoom ? "Home" : (GROUPS.find((g) => g.id === roomId)?.title ?? userRooms.find((r) => r.id === roomId)?.title ?? roomId)}
            roomUrl={`${window.location.origin}${isHomeRoom ? "/" : `/${GROUPS.find((g) => g.id === roomId) ? `~${roomId}` : roomId}`}`}
          />
        )}
      </main>

      {showWelcome && <WelcomeModal onDismiss={dismissWelcome} />}
      <Analytics />
    </div>
  );
}
